import { Union, Record } from "./fable_modules/fable-library.3.7.1/Types.js";
import { links, Router_navigatePage, PageModule_parseUrlSegment, Page$reflection } from "./Router.fs.js";
import { union_type, record_type } from "./fable_modules/fable-library.3.7.1/Reflection.js";
import { RouterModule_router, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { Cmd_none } from "./fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { createElement } from "react";
import * as react from "react";
import { join } from "./fable_modules/fable-library.3.7.1/String.js";
import { Interop_reactApi } from "./fable_modules/Feliz.1.67.0/Interop.fs.js";
import { equals, createObj } from "./fable_modules/fable-library.3.7.1/Util.js";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library.3.7.1/List.js";
import { empty, map, singleton, append, delay, toList } from "./fable_modules/fable-library.3.7.1/Seq.js";
import { Component } from "./Examples/Basic.fs.js";
import { Component as Component_1 } from "./Examples/Groups.fs.js";
import { Component as Component_2 } from "./Examples/Ordering.fs.js";
import { Component as Component_3 } from "./Examples/Pinning.fs.js";
import { Component as Component_4 } from "./Examples/Resizing.fs.js";
import { Component as Component_5 } from "./Examples/EditableData.fs.js";
import { Component as Component_6 } from "./Examples/Expanding.fs.js";
import { Component as Component_7 } from "./Examples/Grouping.fs.js";
import { Component as Component_8 } from "./Examples/PaginationControlled.fs.js";
import { Component as Component_9 } from "./Examples/Sorting.fs.js";
import { view as view_1 } from "./Home.fs.js";

export class State extends Record {
    constructor(Page) {
        super();
        this.Page = Page;
    }
}

export function State$reflection() {
    return record_type("Main.State", [], State, () => [["Page", Page$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["UrlChanged"];
    }
}

export function Msg$reflection() {
    return union_type("Main.Msg", [], Msg, () => [[["Item", Page$reflection()]]]);
}

export function init() {
    return [new State(PageModule_parseUrlSegment(RouterModule_urlSegments(window.location.hash, 1))), Cmd_none()];
}

export function update(msg, state) {
    return [new State(msg.fields[0]), Cmd_none()];
}

export function view(state, dispatch) {
    let elems_2, elems_1, children, elems_5, elems_4, elems_3, elems_8, elems_7, elems_6, elements;
    const colDiv = (e) => createElement("div", {
        className: join(" ", ["column", "is-full"]),
        children: Interop_reactApi.Children.toArray([e]),
    });
    let sourceLinkOpt;
    const some = (s) => (`${"https://github.com/dsshep/Feliz.TanStack.Table/tree/main/src/Docs/Examples/"}${s}.fs`);
    const matchValue = state.Page;
    switch (matchValue.tag) {
        case 1: {
            sourceLinkOpt = some("Basic");
            break;
        }
        case 2: {
            sourceLinkOpt = some("Groups");
            break;
        }
        case 3: {
            sourceLinkOpt = some("Ordering");
            break;
        }
        case 4: {
            sourceLinkOpt = some("Pinning");
            break;
        }
        case 5: {
            sourceLinkOpt = some("Resizing");
            break;
        }
        case 6: {
            sourceLinkOpt = some("EditableData");
            break;
        }
        case 7: {
            sourceLinkOpt = some("Expanding");
            break;
        }
        case 8: {
            sourceLinkOpt = some("Grouping");
            break;
        }
        case 9: {
            sourceLinkOpt = some("PaginationControlled");
            break;
        }
        case 10: {
            sourceLinkOpt = some("Sorting");
            break;
        }
        default: {
            sourceLinkOpt = (void 0);
        }
    }
    let sourceLink;
    if (sourceLinkOpt != null) {
        const l = sourceLinkOpt;
        sourceLink = createElement("section", createObj(ofArray([["className", join(" ", ["container", "has-background-light"])], (elems_2 = [createElement("div", createObj(ofArray([["className", join(" ", ["px-3", "py-2"])], (elems_1 = [(children = ofArray(["View the source code for this example ", createElement("a", {
            children: "here",
            href: l,
        }), "."]), createElement("p", {
            children: Interop_reactApi.Children.toArray(Array.from(children)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }
    else {
        sourceLink = null;
    }
    const sidebar = createElement("div", createObj(ofArray([["className", join(" ", ["tile", "is-3"])], (elems_5 = [createElement("aside", createObj(ofArray([["className", join(" ", ["menu", "pb-2"])], (elems_4 = [createElement("ul", createObj(ofArray([["className", "menu-list"], (elems_3 = toList(delay(() => append(singleton(createElement("p", {
        className: join(" ", ["menu-label", "is-unselectable"]),
        children: "Feliz.TanStack.Table",
    })), delay(() => map((l_1) => {
        const children_2 = singleton_1(createElement("a", {
            className: join(" ", toList(delay(() => append(equals(l_1.Page, state.Page) ? singleton("has-background-primary") : empty(), delay(() => (equals(l_1.Page, state.Page) ? singleton("is-active") : empty())))))),
            children: l_1.Name,
            onClick: (_arg1) => {
                Router_navigatePage(l_1.Page);
            },
        }));
        return createElement("li", {
            children: Interop_reactApi.Children.toArray(Array.from(children_2)),
        });
    }, links))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])));
    const main = createElement("main", createObj(ofArray([["className", join(" ", ["tile", "is-9"])], (elems_8 = [createElement("div", createObj(ofArray([["className", join(" ", ["columns", "is-multiline"])], (elems_7 = [colDiv(createElement("section", createObj(ofArray([["className", "container"], (elems_6 = toList(delay(() => {
        const matchValue_1 = state.Page;
        switch (matchValue_1.tag) {
            case 1: {
                return singleton(createElement(Component, null));
            }
            case 2: {
                return singleton(createElement(Component_1, null));
            }
            case 3: {
                return singleton(createElement(Component_2, null));
            }
            case 4: {
                return singleton(createElement(Component_3, null));
            }
            case 5: {
                return singleton(createElement(Component_4, null));
            }
            case 6: {
                return singleton(createElement(Component_5, null));
            }
            case 7: {
                return singleton(createElement(Component_6, null));
            }
            case 8: {
                return singleton(createElement(Component_7, null));
            }
            case 9: {
                return singleton(createElement(Component_8, null));
            }
            case 10: {
                return singleton(createElement(Component_9, null));
            }
            default: {
                return singleton(view_1());
            }
        }
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])))), colDiv(sourceLink)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])));
    return RouterModule_router(createObj(ofArray([["hashMode", 1], ["onUrlChanged", (arg_1) => {
        dispatch(new Msg(0, PageModule_parseUrlSegment(arg_1)));
    }], (elements = singleton_1(createElement("div", {
        className: join(" ", ["tile", "is-ancestor", "p-6"]),
        children: Interop_reactApi.Children.toArray([sidebar, main]),
    })), ["application", react.createElement(react.Fragment, {}, ...elements)])])));
}

//# sourceMappingURL=Main.fs.js.map
